import Model from '@ember-data/model';
import attr from 'ember-data/attr';

export interface SubscriptionPageSection {
  title: string;
  subtitle: string;
}

export default class SubscriptionPageModel extends Model {
  @attr('camel-case') header!: SubscriptionPageSection;
  @attr('camel-case') footer!: SubscriptionPageSection;

  trimHeader() {
    this.header.title = this.header.title?.trim() ?? '';
    this.header.subtitle = this.header.subtitle?.trim() ?? '';
  }
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'subscription-page': SubscriptionPageModel;
  }
}
